import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

interface Props {
  isDrawerOpen: boolean;
  toggleSidebar: () => void;
}

export const ToggleSidebarSection = ({ isDrawerOpen, toggleSidebar }: Props) => {
  return (
    <ListItem onClick={toggleSidebar} disableGutters>
      <ListItemButton>
        <ListItemIcon>
          <MenuOpenIcon sx={{ color: 'white', transform: !isDrawerOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
        </ListItemIcon>
        <ListItemText primary="Hide Sidebar" />
      </ListItemButton>
    </ListItem>
  );
};
